import { actionConstants } from './actionConstants';
import noti from './toast';
import { get, put } from './method';
import { sortBy } from 'lodash';
import helper from '../utils/helper';
import moment from 'moment';

export const generalActions = {
  getCurrentProfile,
  updateCurrentProfile,
  clearError,
  clearData,
  initSession,
  checkSession,
  getServerVersion,
  getHelpDocuments,
  downloadHelpDocument,
};

export function getCurrentProfile() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get('app/users/current/profile')
      .then((resp) => {
        localStorage.setItem('userProfile', JSON.stringify(resp));
        dispatch({
          type: actionConstants.GET_CURRENT_PROFILE_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_CURRENT_PROFILE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

const parseTime = (time) => {
  const hour = new Date(time).getHours();
  const minute = new Date(time).getMinutes();
  return `${hour}:${minute < 10 ? '0' + minute : minute}`;
};

function updateCurrentProfile(_params) {
  const p = Object.assign({}, _params);
  let params = {
    body: {
      ...p,
      workDaysOfWeek: sortBy(p.workDaysOfWeek).join(','),
      startWork: parseTime(p.startWork),
      endWork: parseTime(p.endWork),
    },
  };
  return async (dispatch) => {
    return await put('app/users/current/profile', params)
      .then((resp) => {
        noti.success(`Your profile is updated`);
        dispatch({
          type: actionConstants.UPDATE_CURRENT_PROFILE_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.UPDATE_CURRENT_PROFILE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function initSession() {
  return async (dispatch, getState) => {
    const expired = helper.updateExpiredTime();
    localStorage.setItem('expired', expired);
    localStorage.setItem('isSessionInitialized', true);
  };
}

function checkSession() {
  return (dispatch, getState) => {
    const expired = localStorage.getItem('expired');
    return moment().isSameOrAfter(expired);
  };
}

function getServerVersion() {
  return async (dispatch, getState) => {
    const { serverVersion } = getState().general;
    if (!serverVersion) {
      return await get('app/versions/current')
        .then((resp) => {
          dispatch({
            type: actionConstants.GET_SERVER_VERSION_SUCCESS,
            data: resp,
          });
        })
        .catch((error) => {
          noti.error(error.response.data.error.message);
          dispatch({
            type: actionConstants.GET_SERVER_VERSION_FAILURE,
            data: error.response.data.error.message,
          });
          throw error.response.data.error.message;
        });
    }
  };
}

function getHelpDocuments() {
  return async (dispatch) => {
    return await get('app/documents')
      .then((resp) => {
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function downloadHelpDocument(documentName) {
  const params = {
    responseType: 'blob',
  };
  return async (dispatch) => {
    return await get(`app/documents/${documentName}`, params)
      .then((resp) => {
        // let filename = '';
        // const disposition = resp.headers['content-disposition'];
        // if (disposition && disposition.indexOf('attachment') !== -1) {
        //   let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        //   let matches = filenameRegex.exec(disposition);
        //   if (matches != null && matches[1]) {
        //     filename = matches[1].replace(/['"]/g, '');
        //   }
        // }
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', documentName); //or any other extension
        document.body.appendChild(link);
        link.click();
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function clearError() {
  return (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
  };
}

function clearData() {
  return (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_DATA });
  };
}
